import { EdgyCloseNext } from '@tv2/ui-system/icons/next/general/EdgyCloseNext';
import { InformationNext } from '@tv2/ui-system/icons/next/navigation/InformationNext';
import { CheckNext } from '@tv2/ui-system/icons/next/general/CheckNext';

import type { JSX } from 'react';

export function CardActionIcon({
  icon,
  className,
}: {
  icon: string | null;
  className: string;
}): JSX.Element | null {
  switch (icon) {
    case 'info':
      return <InformationNext className={className} />;
    case 'x':
      return <EdgyCloseNext className={className} alt="Slet fra se videre" />;
    case 'check':
      return <CheckNext className={className} />;
  }
  return null;
}
